import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { omit } from 'lodash';
import CandidateCountry from '../CandidateCountry/CandidateCountry';
import SocialIcons from '../Badges/SocialIcons/SocialIcons';
import { ShowData, useShowContext } from 'framework/show';
import { useFormContext } from 'framework/form';
import CandidateProfileTag from '../Badges/CandidateProfileTag/CandidateProfileTag';
import CandidateResumeBadge from '../Badges/ResumeBadge/CandidateResumeBadge';
import CandidateEnglishLevelLang from '../CandidateEnglishLevelLang/CandidateEnglishLevelLang';
import CandidateNativeLang from '../CandidateNativeLang/CandidateNativeLang';
import { Stack, Typography } from '@mui/material';

interface NameFieldValue {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  maidenName?: string;
}

const ProfileDetails = ({ ignoredNameParts = [] }: FieldProps<NameFieldValue>) => {
  const { getValue } = useFieldHelper({ source: 'name' });
  const nameField = omit(getValue() || {}, ignoredNameParts) as any;

  const formContext = useFormContext();
  const showContext = useShowContext();
  const data = (showContext?.data.isNotEmpty() && showContext.data) || new ShowData(formContext?.data || {});

  return (
    <Stack direction="column">
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} mb={0.5}>
        <Typography variant="h3" color="brand">
          {nameField.fullName}
        </Typography>
        <Stack justifyContent="space-between" alignItems="center" direction="row" gap={1}>
          <CandidateCountry />
          <SocialIcons />
        </Stack>
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap={0.5} mb={2}>
        {data.getValueBySource('isStudent') && <CandidateProfileTag tagText="Student" backgroundColor="warning" />}
        {!data.getValueBySource('isInBlackList') && data.getValueBySource('isMarkedAsPotentialCandidate') && (
          <CandidateProfileTag tagText="KIV" backgroundColor="secondary" />
        )}
        {!data.getValueBySource('isInBlackList') && data.getValueBySource('isReferral') && (
          <CandidateProfileTag tagText="Referral" backgroundColor="primary" />
        )}
        {data.getValueBySource('isInBlackList') && (
          <CandidateProfileTag tagText="Blacklist" backgroundColor="default" />
        )}
        {data.getValueBySource('isHidden') && <CandidateProfileTag tagText="Hidden" backgroundColor="default" />}
        {data.getValueBySource('duplicateOf') && <CandidateProfileTag tagText="Duplicate" backgroundColor="error" />}
        {data.getValueBySource('convertedToEmployeeId') && (
          <CandidateProfileTag tagText="Converted" backgroundColor="success" />
        )}
      </Stack>
      <Stack direction="row" gap={1} justifyContent="space-between">
        <Stack direction="row" gap={1}>
          <CandidateNativeLang />
          <CandidateEnglishLevelLang />
        </Stack>
        <CandidateResumeBadge />
      </Stack>
    </Stack>
  );
};

export default ProfileDetails;
